import { css } from '@emotion/react'

export const textEllipsis = (line: number) => css`
  display: -webkit-box;
  overflow: hidden;
  word-break: break-all;
  -webkit-line-clamp: ${line};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`
